var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"expo-btn expo-btn-white",attrs:{"type":"button","title":_vm.$t('general.save')},on:{"click":function($event){return _vm.click()}}},[_c('save-icon')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }